export default __webpack_public_path__ + "static/media/ISKO CLASS 2 SYLLABUS.cd272c5c.pdf";